var _circle, _path, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8775 45.0725L46.7493 38.8794C47.7731 36.8105 48.3144 34.5044 48.318 32.1837C48.3241 28.1877 46.7784 24.4091 43.9643 21.5441C41.1495 18.6785 37.4 17.0656 33.4046 17.0021C31.3116 16.9681 29.2803 17.3544 27.3647 18.147C25.5168 18.9116 23.8603 20.0196 22.4399 21.44C21.0195 22.8604 19.9116 24.5169 19.1469 26.3647C18.3538 28.2804 17.9687 30.3123 18.002 32.4047C18.065 36.4 19.6779 40.1496 22.5435 42.9643C25.4024 45.7724 29.1713 47.3181 33.1588 47.3181C33.1667 47.3181 33.1745 47.3181 33.1824 47.3181C35.5031 47.3145 37.8093 46.7732 39.8781 45.7494L46.0712 47.8775C46.3092 47.9593 46.5538 47.9992 46.7947 47.9992C47.3681 47.9992 47.9263 47.774 48.3495 47.3508C48.952 46.7496 49.1536 45.8765 48.8775 45.0725Z",
    fill: "#FAFAFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.1194,
    cy: 32.4998,
    r: 2.21412
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4998,
    cy: 32.4998,
    r: 2.21412
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.8802,
    cy: 32.4998,
    r: 2.21412
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineChat);
export default __webpack_public_path__ + "static/media/online-chat.6ae68145.svg";
export { ForwardRef as ReactComponent };